import { render } from "./CustomerListRow.vue?vue&type=template&id=c31f7744&ts=true"
import script from "./CustomerListRow.vue?vue&type=script&lang=ts"
export * from "./CustomerListRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__